var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4843 13.1202L13.1264 19.4797C12.9617 19.6447 12.7661 19.7755 12.5509 19.8648C12.3356 19.9541 12.1048 20 11.8717 20C11.6387 20 11.4079 19.9541 11.1926 19.8648C10.9773 19.7755 10.7817 19.6447 10.617 19.4797L3 11.8696V3H11.8673L19.4843 10.619C19.8146 10.9514 20 11.401 20 11.8696C20 12.3383 19.8146 12.7879 19.4843 13.1202Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H7.01",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.e3f90f7fac3e79801bd93cea04bceff0.svg";
export { ForwardRef as ReactComponent };